import * as Utils from './application-information-forms-utils';
import { Validator } from 'formstate';
import moment from 'moment';

const EMAIL_REGEXP =
    /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
const SSN_REGEXP = /^(X|\d){3}-(X|\d){2}-\d{4}$/i;
const PHONE_REGEXP = /^\(\d{3}\)\s\d{3}-\d{4}$/i;

export const emailValidator: Validator<string> = (value) => {
    if (value === null || value.length === 0) {
        return 'Value is required';
    }
    return EMAIL_REGEXP.test(value) ? false : 'Email address is invalid';
};

export const issueDateValidator: Validator<string> = (value) => {
    if (value === null || value.length === 0) {
        return 'Value is required';
    }
    return new Date(moment(value).format('L')) < new Date()
        ? false
        : 'Issue date must be in the past';
};

export const expDateValidator: Validator<string> = (value) => {
    if (value === null || value.length === 0) {
        return 'Value is required';
    }
    const today = new Date(moment(new Date()).format('L'));
    return new Date(moment(value).format('L')) >= today
        ? false
        : 'Expiry date must be in the future';
};

export const housingPaymentValidator: Validator<string> = (value) => {
    if (value === null) {
        return false;
    }

    return parseFloat(Utils.formatAmount(value)) <= 99999.99
        ? false
        : 'Please provide your monthly payments';
};

export const ssnValidator: Validator<string> = (value) => {
    if (value === null || value.length === 0) {
        return 'Value is required';
    }
    return SSN_REGEXP.test(value) ? false : 'Please enter valid SSN';
};

export const phoneNumberValidator: Validator<string> = (value) => {
    if (value === null || value.length === 0) {
        return 'Value is required';
    }
    return PHONE_REGEXP.test(value) ? false : 'Phone number is invalid';
};

export const ageValidator: Validator<string> = (value) => {
    if (value === null || value.length === 0) {
        return 'Value is required';
    }
    const age = moment(new Date()).diff(moment(value).format('YYYY-MM-DD'), 'years', true);
    return age >= 18 ? false : 'Applicant must be 18 years old or older';
};

export const spouseContactValidator: Validator<string> = (value) => {
    if (value === null || value.length === 0) {
        return 'Value is required';
    }
    return PHONE_REGEXP.test(value) || EMAIL_REGEXP.test(value)
        ? false
        : 'Spouse contact information is invalid';
};

export const minimumAmountValidator: Validator<string> = (value) => {
    if (value === null) {
        return false;
    }
    return parseFloat(value.replace(/\D/g, '')) > 0
        ? false
        : 'Please enter an amount greater than $0';
};
